import { NgModule } from "@angular/core";
import { BnComparacaoABModule } from "src/app/shared/modules/bn-comparacao.module";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaClienteComponent } from "./aba-cliente.component";

@NgModule({
    declarations: [AbaClienteComponent],
    imports:[BnComparacaoABModule,SharedModule],
    exports:[AbaClienteComponent]
})
export class AbaClienteModule {}